module.exports = __webpack_public_path__ + "img/LightBulb.e9b4062e.png";